import { render, staticRenderFns } from "./DateStyle.vue?vue&type=template&id=25b40206&"
import script from "./DateStyle.vue?vue&type=script&lang=ts&"
export * from "./DateStyle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports